import React from "react";
import AdminProductsGet from "./AdminProductsComps/AdminProductsGet";
import AdminProductsCreate from "./AdminProductsComps/AdminProductsCreate";

export default function AdminProductsMP() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <a
        style={{
          marginTop: 20,
          fontSize: 20,
          fontWeight: 500,
        }}
      >
        Products Page
      </a>
      <AdminProductsGet />
      <AdminProductsCreate />
    </div>
  );
}
